/**
 * ANQ.ContentServiceManagement.API 
 * Content Service Mgt API
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ContentTransactionLogDto { 
    transactionId?: string;
    serviceId?: string;
    contentId?: string;
    serviceProviderId?: string;
    channel?: string;
    transactionTimeStamp?: Date;
    content?: string;
    countryCode?: string;
    status?: number;
    phoneNumber?: string;
    messageResponse?: string;
}